import { slideComponents } from "../../utils/consts/2dSliderInfo";
import './styles/slider.css';
import clickSound from '../../Interface/click_Sound.mp3'

const clickSoundInstance = new Audio(clickSound);
clickSoundInstance.volume = 0.15;

const Slider = ({ sliderIndex, setNewSliderIndex }) => {
    const scrollModalToTop = () => {
        const modalContent = document.querySelector('.modal_content');
        if (modalContent) {
            modalContent.scrollTo({
                top: 0,
                behavior: "smooth"
            });
        }
    };

    const playClickSound = () => {
        clickSoundInstance.currentTime = 0; 
        clickSoundInstance.play();
    }

    const handleSliderIndex = (newIndex) => {
        playClickSound();
        scrollModalToTop();
        setNewSliderIndex(newIndex);
    };

    const handleNextClick = () => {
        playClickSound();
        scrollModalToTop();

        if(sliderIndex >= slideComponents.length - 1) {
            setNewSliderIndex(0);
            return;
        }
        setNewSliderIndex(sliderIndex + 1);
    }

    const handlePrevClick = () => {
        playClickSound();
        scrollModalToTop();

        if(sliderIndex <= 0) {
            setNewSliderIndex(slideComponents.length - 1);
            return;
        }
        setNewSliderIndex(sliderIndex - 1);
    }

    return (
        <div className="slider_container">
            <div className="prev_button_container">
                <button onClick={handlePrevClick} className="slider_prev_button">{'<'}</button>
            </div>
            {Array.from({length: slideComponents.length}).map((_, index) => (
                <button key={index} className={`slider_dot ${index === sliderIndex ? 'active' : ''}`} onClick={() => handleSliderIndex(index)}></button>
            ))}
            <div className="next_button_container">
                <button onClick={handleNextClick} className="slider_next_button">{'>'}</button>
            </div>
        </div>
    )
}

export default Slider;